import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const ArrowBack = createSvgIcon(
  <path d="M18.729 1.604 8.444 12l10.284 10.396-1.6 1.582L5.28 12 17.13.02l1.6 1.583Z" />,
  'ArrowBack'
);

export { ArrowBack };
